import { offset, duration, isSmallViewport } from '@/assets/js/hero/helpers'

const SHOW_DURATION = duration(2.25)

/* eslint-disable */
// `hideOffset` is relative to `showOffset`
// all offsets are in percentage
const createFinishLine = (line, { showScale = 0.95 } = {}) => {
  const scale = isSmallViewport() ? showScale + 0.25 : showScale

  return new TimelineMax()
    .to(
      line,
      SHOW_DURATION - offset(SHOW_DURATION, Math.abs(1 - scale)),
      { scaleX: scale, ease: Power1.easeOut },
      offset(SHOW_DURATION, Math.abs(1 - scale))
    )
}


export default createFinishLine



// WEBPACK FOOTER //
// ./src/assets/js/hero/finish.js